module.exports = __webpack_public_path__ + "img/lvyoulei.6ffe3b09.png";